<div class="externe-daten">
  <ng-container>
    <cap-alert-list [alertLevel]="alertLevelContentHeader"></cap-alert-list>
  </ng-container>
  <cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueckbeschreibung">
    <ng-container title>
      <h2 class="mb-0">{{ "GWRGebaeude" | translate }}</h2>
    </ng-container>
    <cap-gwr-gebaeude-table [listLoader]="listLoaderGebaeude" [showTotal]="false" [showZeilenSelect]="false"></cap-gwr-gebaeude-table>
  </cap-rubrik>
  <cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueckbeschreibung">
    <ng-container title>
      <h2 class="mb-0">{{ "GWRBauprojekte" | translate }}</h2>
    </ng-container>
    <cap-gwr-bauprojekt-table [listLoader]="listLoaderBauprojekte" [showTotal]="false" [showZeilenSelect]="false">
    </cap-gwr-bauprojekt-table>
  </cap-rubrik>
</div>
